export default {
  Auth: {
    clientId: import.meta.env.VUE_APP_OAUTH2_CLIENT_ID,
    authority: import.meta.env.VUE_APP_OAUTH2_AUTHORIZE_URL,
    token_url: import.meta.env.VUE_APP_OAUTH2_TOKEN_URL,
    logout_url: import.meta.env.VUE_APP_OAUTH2_LOGOUT_URL,
  },
};
